import React from 'react'
import cn from 'classnames'

import styles from './style.module.css'

interface Props {
    className?: string
    subtitleClassName?: string
    contentClassName?: string
    img?: React.ReactNode
    title: React.ReactNode
    subtitle?: React.ReactNode
    children: React.ReactNode
    dataPointer?: string
}

function ModalView(props: Props) {
    return (
        <div data-pointer={props.dataPointer} className={cn(styles.wrap, props.className)}>
            {props.img}
            <div className={styles.title}>{props.title}</div>
            {props.subtitle && <div className={cn(styles.subtitle, props.subtitleClassName)}>{props.subtitle}</div>}
            <div data-pointer="modal_view_content" className={cn(styles.content, props.contentClassName)}>
                {props.children}
            </div>
        </div>
    )
}

export default ModalView
